module.exports = __webpack_public_path__ + "static/media/kanasta-scenario.b24fe6bd.png";